/**
 * @fileoverview Utilidades de detección de dispositivo.
 * @module utils/device
 */

const MOBILE_USER_AGENT = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i

/**
 * Indica si el user agent corresponde a un dispositivo móvil.
 * Detecta por user agent, no por ancho de pantalla.
 * @param {string} [userAgent=navigator.userAgent] - User agent a evaluar
 * @returns {boolean} true si es Android, webOS, iPhone, iPad, iPod, BlackBerry o Windows Phone
 */
export function isMobileDevice (userAgent = navigator.userAgent) {
  return MOBILE_USER_AGENT.test(userAgent)
}



// WEBPACK FOOTER //
// ./src/utils/device.js